import { render } from "./IconMoto.vue?vue&type=template&id=1355134a"
import script from "./IconMoto.vue?vue&type=script&lang=js"
export * from "./IconMoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__